module.exports = __webpack_public_path__ + "static/media/employee.24c12847.svg";